import React from 'react';

import { DropZoneAreaBase } from './DropZoneAreaBase';
import { fileToFileObject } from './helpers';

import type { DropZoneProperties, FileObject } from './DropZone.types';

export const DropZone: React.FC<DropZoneProperties> = ({
  dataTest = 'dropzone',
  accept,
  filesLimit = 1,
  filesCount,
  icon,
  maxFileSize,
  dropzoneText,
  getFileLimitExceedMessage,
  getDropRejectMessage,
  onDrop,
  onDropRejected,
  inputProps,
  dropzoneProps,
  dropZoneStyles,
  dropzoneParagraphStyles,
  acceptedFormatsText,
  rejectionErrorDataTest,
  limitErrorDataTest,
}) => {
  const [fileObjects, setFileObjects] = React.useState<FileObject[]>([]);

  // Счётчик файлов бывает двух видов. Controlled — потребитель передал `filesCount`
  // и сам владеет списком: только он знает про удаление файлов, поэтому внутренний
  // накопитель здесь не ведём, иначе он разойдётся с реальностью и заблокирует
  // добавление после удаления. Uncontrolled — списка снаружи нет, удалять нечему,
  // и накопитель остаётся единственным источником счёта.
  const isFilesCountControlled = filesCount !== undefined;

  const addFiles = async (newFiles: File[]) => {
    if (isFilesCountControlled) {
      return;
    }
    // Снимок файла собирает helper: он же разбирает случай файла без `path`,
    // недостижимый через DOM-сценарии, — разбор в `fileToFileObject`.
    const newFileObjects = newFiles.map(file => fileToFileObject(file));
    setFileObjects(previous => [...previous, ...newFileObjects]);
  };

  return (
    <DropZoneAreaBase
      dataTest={dataTest}
      accept={accept}
      filesLimit={filesLimit}
      icon={icon}
      filesCount={filesCount ?? fileObjects.length}
      maxFileSize={maxFileSize}
      dropzoneText={dropzoneText}
      getFileLimitExceedMessage={getFileLimitExceedMessage}
      getDropRejectMessage={getDropRejectMessage}
      onAdd={addFiles}
      onDrop={onDrop}
      onDropRejected={onDropRejected}
      inputProps={inputProps}
      dropzoneProps={dropzoneProps}
      dropZoneStyles={dropZoneStyles}
      dropzoneParagraphStyles={dropzoneParagraphStyles}
      acceptedFormatsText={acceptedFormatsText}
      rejectionErrorDataTest={rejectionErrorDataTest}
      limitErrorDataTest={limitErrorDataTest}
    />
  );
};
